import { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { Lock } from "lucide-react";
import {
  MAX_SCHEDULE_NOTE_LENGTH,
  truncateScheduleNote,
} from "../../utils/scheduleNote";

type Props = {
  open: boolean;
  slotCount: number;
  isLoading: boolean;
  onConfirm: (note: string) => void;
  onClose: () => void;
};

export default function ModalScheduleLockNote({
  open,
  slotCount,
  isLoading,
  onConfirm,
  onClose,
}: Props) {
  const [note, setNote] = useState("");

  useEffect(() => {
    if (!open) {
      setNote("");
    }
  }, [open]);

  const title =
    slotCount > 1
      ? `Bloquear ${slotCount} horários`
      : "Bloquear horário";

  function handleConfirm() {
    onConfirm(truncateScheduleNote(note));
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      classNames={{
        modal: "schedule-lock-note-modal",
      }}
    >
      <div className="mx-auto flex w-full flex-col">
        <div className="flex items-center gap-3">
          <Lock className="h-8 w-8 shrink-0 text-slate-700" aria-hidden />
          <div className="text-left">
            <p className="text-lg font-bold text-slate-800 sm:text-xl">
              {title}
            </p>
          </div>
        </div>

        <label className="mt-5 block text-left text-sm font-medium text-slate-700">
          Motivo do bloqueio (opcional)
          <textarea
            value={note}
            onChange={(event) =>
              setNote(event.target.value.slice(0, MAX_SCHEDULE_NOTE_LENGTH))
            }
            rows={4}
            placeholder="Ex.: consultor em reunião externa, treinamento interno..."
            className="mt-2 w-full resize-none rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 placeholder:text-slate-400 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400/30"
          />
        </label>

        <p className="mt-1 text-right text-xs text-slate-400">
          {note.length}/{MAX_SCHEDULE_NOTE_LENGTH}
        </p>

        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rounded-md border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-60"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className="rounded-md bg-slate-800 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-900 disabled:opacity-60"
          >
            {isLoading ? "Bloqueando..." : "Confirmar bloqueio"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
